(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.services')
		.service('CouponService', CouponService)

	/** @ngInject */
	function CouponService(HttpService, $httpParamSerializer, $httpParamSerializerJQLike) {
		let searchTerm;

		const CouponService = {
			getByParameters,
			getCategoriesByParameters,
			get,
			post,
			put,
			remove,
			use,
			setSearchTerm,
			getSearchTerm
		};

		return CouponService;

		function getByParameters(params) {
			let serializedParams = $httpParamSerializerJQLike(params);
			return HttpService.get(`/coupon/get-by-parameters-for-app?${serializedParams}`);
		}

		function getCategoriesByParameters(params) {
			let serializedParams = $httpParamSerializer(params);

			return HttpService.get(`/business-category/get-by-parameters?${serializedParams}`);
		}

		function get(couponId) {
			return HttpService.get(`/coupon${couponId}`);
		}

		function post(couponData) {
			return HttpService.post('/coupon', couponData);
		}

		function use(couponData) {
			return HttpService.post('/coupon/use', couponData);
		}

		function put(couponData) {
			return HttpService.put('/coupon', couponData);
		}

		function remove(couponId) {
			return HttpService.delete(`/coupon/${couponId}`);
		}

		function setSearchTerm(term) {
			searchTerm = term;
		}
		function getSearchTerm() {
			return searchTerm;
		}
	}
}());